import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadListProductGroups } from '@/api/react-query'

// `listQ` searches the group list in the left column; `q`, `limit` and `offset` belong to the detail
// route's product table in the right one. Both panels are mounted at once, so the group list keeps
// its paging in local state rather than sharing the URL's `offset` with the products beside it.
const GroupSearchSchema = z.object({
	listQ: z.string().optional(),
	sortBy: z.enum(['name', 'productCount']).optional(),
	sortOrder: z.enum(['asc', 'desc']).optional()
})

export const Route = createFileRoute('/_authenticated/_general/product-groups')({
	validateSearch: GroupSearchSchema,
	loaderDeps: ({ search: { listQ, sortBy, sortOrder } }) => ({ listQ, sortBy, sortOrder }),
	loader: async ({ context, deps: { listQ, sortBy, sortOrder } }) =>
		await preloadListProductGroups(context, {
			query: { q: listQ, sortBy, sortOrder }
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.ProductGroups.Breadcrumb()
	}
})
